import { render, staticRenderFns } from "./questionListEditor.vue?vue&type=template&id=21398e2b&scoped=true"
import script from "./questionListEditor.vue?vue&type=script&lang=js"
export * from "./questionListEditor.vue?vue&type=script&lang=js"
import style0 from "./questionListEditor.vue?vue&type=style&index=0&id=21398e2b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21398e2b",
  null
  
)

export default component.exports